module.exports = __webpack_public_path__ + "static/upperleft_box-b49f92a0404acf3534829fb887120070.png";